type CompanyWithStripe = {
  stripe?: {
    customerId?: string;
    customer?: { id?: string } | null;
  } | null;
};

/**
 * Stripe customer id for a company. The flat stripe.customerId field is
 * canonical since the company stripe shape was flattened; the nested
 * stripe.customer.id shape is still synthesized by the API for backward
 * compatibility, so it is kept here as a fallback until that shim is
 * removed. A company with neither (for example Recurly-only) returns
 * undefined.
 */
const getStripeCustomerId = (
  company?: CompanyWithStripe | null
): string | undefined =>
  company?.stripe?.customerId ?? company?.stripe?.customer?.id;

export default getStripeCustomerId;
